import * as React from 'react';
import { InputField } from '@inmoment/the-kitchen';

type InputFieldProps = Parameters<typeof InputField>[0];

export interface Props {
  height?: number;
  width?: number;
  propName: string;
  value?: string;
  placeholder: string;
  onChange: Required<InputFieldProps>['onChange'];
}

export const InputControl: React.FC<Props> = (props) => {
  const { propName, placeholder, onChange, value } = props;

  return <InputField value={value} style={{ marginBottom: 18 }} onChange={onChange} placeholder={placeholder} label={propName} />;
};
